import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import FormList from '../../components/FormList';
import Forms from '../../api/forms';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg';
import { useLanguage } from '../../context/LanguageContext';

const BilgiFormlariPage = () => {
    const { t } = useLanguage();
    const forms = Forms;

    return (
        <Fragment>
            <SEO title={t('pages.forms')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.forms')} pagesub={t('pages.forms')} bgImage={'/banner/bilgi-formlari.png'} />
            <section className="wpo-shop-page section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <FormList forms={forms} />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default BilgiFormlariPage;
